'use client';

import { cn } from 'cn';

import { CheckIcon } from '../icons';

export type FilterPillGroupProps<TValue extends string> = {
  legend: string;
  options: ReadonlyArray<{ value: TValue; label: string }>;
  selected: ReadonlyArray<TValue>;
  onToggle: (value: TValue) => void;
  disabled?: boolean;
};

export function FilterPillGroup<TValue extends string>({
  legend,
  options,
  selected,
  onToggle,
  disabled = false,
}: FilterPillGroupProps<TValue>) {
  return (
    <fieldset>
      <legend className="typography-text-large mb-2">{legend}</legend>
      <div className="flex flex-wrap gap-2">
        {options.map(option => {
          const isSelected = selected.includes(option.value);

          return (
            <button
              key={option.value}
              type="button"
              aria-pressed={isSelected}
              disabled={disabled}
              onClick={() => onToggle(option.value)}
              className={cn(
                'focus-visible:focus-ring inline-flex items-center gap-1.5 rounded-full border border-input px-2 py-1.5 text-sm font-medium outline-none disabled:pointer-events-none disabled:opacity-50',
                isSelected && 'border-primary bg-primary text-primary-foreground',
              )}
            >
              {isSelected ? <CheckIcon className="size-4" /> : null}
              {option.label}
            </button>
          );
        })}
      </div>
    </fieldset>
  );
}
